export const ADMIN_SEARCH_BASE_URL = '/admin/search';

export const ALGOLIA_SEARCH_DEBOUNCE_MS = 300;

export enum AdminSearchParamOptions {
  QUERY = 'query',
  CONTENT_SOURCES = 'contentSources',
}

export enum AdminSearchContentTypes {
  GUIDE = 'guide',
  PATH = 'path',
  LIBRARY = 'library',
  RESOURCE = 'resource',
  CHALLENGE = 'challenge',
  SCORM = 'scorm',
  EVENT = 'event',
  CONTENT_PROVIDER_CONTENT = 'content_provider_content',
  ITEM_FOLDER = 'item_folder',
}

export enum GuideSubTypes {
  SECTION = 'guide_section',
  TASK = 'guide_task',
}

export enum AdminSearchContentSources {
  LINKEDIN_LEARNING = 'linkedin_learning',
  UDEMY = 'udemy',
}
